import { useEffect, useRef } from "react"
import { sanitizeSvgMarkup } from "../utils/sanitizeSvg"

/**
 * Renders admin-provided SVG markup after stripping scripts and event handlers.
 * Uses DOMParser + replaceChildren instead of dangerouslySetInnerHTML.
 */
export default function SafeSvg({ svg, className, style }) {
    const containerRef = useRef(null)

    useEffect(() => {
        const container = containerRef.current
        if (!container) return

        const safe = sanitizeSvgMarkup(svg)
        if (!safe) {
            container.replaceChildren()
            return
        }

        const doc = new DOMParser().parseFromString(safe, "image/svg+xml")
        if (doc.querySelector("parsererror")) {
            container.replaceChildren()
            return
        }

        const svgEl = doc.documentElement
        if (!svgEl || svgEl.nodeName.toLowerCase() !== "svg") {
            container.replaceChildren()
            return
        }

        container.replaceChildren(svgEl)
    }, [svg])

    return <div ref={containerRef} className={className} style={style} />
}
